import {NgModule, Optional, SkipSelf} from "@angular/core";
import {CoreView} from "./_views/core.view";
import {AppNavigationView} from "./app-navigation/_views/app-navigation.view";
import {AssetRepository} from "../common/repositories/asset.repository";
import {RouterModule} from "@angular/router";
import {CommonModule} from "@angular/common";
import {RouterNotificationGuard} from "../common/guards/router-notification.guard";
import {AuthGuard} from "../common/guards/auth.guard";
import {ToastModule} from "primeng/toast";
import {ToastMessageService} from "../common/services/toast-message.service";
import {MessageService} from "primeng/api";
import {TranslationRepository} from "../common/repositories/translation.repository";
import {LineRepository} from "../common/repositories/line.repository";
import {ScreenAccessRepository} from "../common/repositories/screen-access.repository";
import {AccessControlGuard} from "../common/guards/access-control.guard";
import {ScreenConfigRepository} from "../common/repositories/screen-config.repository";
import {SharedModule} from "../shared-modules/shared-module/shared.module";
import {UserRepository} from "../common/repositories/user.repository";
import {CustomDatesService} from "../common/services/custom-dates.service";
import {ClientRepository} from "../common/repositories/client.repository";
import {LanguageRepository} from "../common/repositories/language.repository";
import {PlantRepository} from "../common/repositories/plant.repository";
import {GlobalObjectsRefService} from "../common/services/global-objects-ref.service";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {HttpInterceptorService} from "./_interceptors/http-interceptor.service";
import {ToastAlertService} from "../common/services/toast-alert.service";
import {MobileAppHeaderView} from "./mobile-app-header/_views/mobile-app-header.view";
import {AlertRuleHistoryRepository} from "../common/repositories/alert-rule-history.repository";

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    ToastModule,
    SharedModule,
  ],
  declarations: [
    CoreView,
    AppNavigationView,
    MobileAppHeaderView,
  ],
  exports: [
    CoreView,
  ],
  providers: [
    AuthGuard,
    AccessControlGuard,
    RouterNotificationGuard,
    ClientRepository,
    PlantRepository,
    AssetRepository,
    LineRepository,
    ScreenAccessRepository,
    TranslationRepository,
    ScreenConfigRepository,
    LanguageRepository,
    AlertRuleHistoryRepository,
    MessageService,
    ToastMessageService,
    ToastAlertService,
    UserRepository,
    CustomDatesService,
    GlobalObjectsRefService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true },
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if(parentModule) {
      throw new Error("CoreModule is already loaded. Import it in the AppModule only");
    }
  }
}
